module.exports = __webpack_public_path__ + "static/img/rule.1d9488b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/wordHunt/light/rule.png
// module id = qY9R
// module chunks = 1